import React from 'react'
import { FormattedMessage } from 'react-intl'

export const getTranslationForKey = (messageId, values = null) => (
  <FormattedMessage id={messageId} values={values} />
)
